import React, { Component } from 'react';
import './users.scss';
import SessionCache from '../routes/session-cache';
import SchoolApi from '../../apis/school'
import Teachers from '../teachers/teachers-list';
import { getImageSource } from '../../utility/image-source';
import { ImageConstants } from '../../constants/constants';
import Contacts from '../contacts/contacts';
import AdminUsers from '../admin-users/admin-users';
import Coordinators from '../coordinators/coordinators';
import Path from '../routes/routes-path';
const TABS =[{ title: "Teachers", value: "TEACHERS" },
{ title: "Management", value: "MANAGEMENT" },
{ title: "Admins", value: "ADMIN" },
{ title: "Event Coordinators", value: "COORDINATORS" }]
class Users extends Component {

    state = {
        activeTabIndex: 0
    }

    accessRights = SessionCache.getAllowedModule()
    user = SessionCache.getUser()

    onClickTab = tabIdx => {
        this.setState({
            activeTabIndex: tabIdx
        })
    }
    getTabs = () => {
        return (<div>
            {TABS.map((tab, index) => (
                <div
                    key={'tab' + index}
                    className={`tab mr-3 ${tab.value === "COORDINATORS" ? 'hidden-sm' : ''} ${
                        this.state.activeTabIndex == index ? 'tab-active' : ''
                    }`}
                    onClick={() => this.onClickTab(index)}
                >
                    <div className='tab-center'>
                        <span>{tab.title}</span>
                    </div>

                    {this.state.activeTabIndex == index ? (
                        <div className='active-cirlce'></div>
                    ) : (
                        ''
                    )}
                </div>
            ))}
        </div>)
    }
    render() {
        const {activeTabIndex} = this.state;
        return (
            <div className='users'>
                {/* <div className='mb-5 cursor-pointer' onClick={_ => this.props.history.push({pathname: Path.STANDARD_HOMEWORK, showList: true})}>
                    <img
                        className='ad-banner'
                        src={getImageSource(ImageConstants.AD_BANNER_1)}
                    />
                </div> */}
                <div className='header-container'>
                    <span className='screen-title'>USERS</span>
                </div>
                <div>
                  {this.getTabs()}  
                </div>
                <div className='pt-5'>
                    {activeTabIndex === 0 && 
                        <Teachers {...this.props} />
                    }
                    {activeTabIndex === 1 && 
                        <Contacts {...this.props} />
                    }
                    {activeTabIndex === 2 && 
                        <AdminUsers {...this.props} />
                    }
                    {activeTabIndex === 3 && 
                        <Coordinators {...this.props} type={"COORDINATOR"} />
                    }
                </div>
            </div>

        )
    }

}

export default Users;